var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponUnSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    viewBox: "0 0 25 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0137 7.32422C15.2251 7.32422 16.2109 6.33838 16.2109 5.12695C16.2109 3.91553 15.2251 2.92969 14.0137 2.92969C12.8022 2.92969 11.8164 3.91553 11.8164 5.12695C11.8164 6.33838 12.8022 7.32422 14.0137 7.32422ZM14.0137 4.39453C14.4175 4.39453 14.7461 4.72314 14.7461 5.12695C14.7461 5.53076 14.4175 5.85938 14.0137 5.85938C13.6099 5.85938 13.2812 5.53076 13.2812 5.12695C13.2812 4.72314 13.6099 4.39453 14.0137 4.39453Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 10.9863C17.6758 12.1978 18.6616 13.1836 19.873 13.1836C21.0845 13.1836 22.0703 12.1978 22.0703 10.9863C22.0703 9.7749 21.0845 8.78906 19.873 8.78906C18.6616 8.78906 17.6758 9.7749 17.6758 10.9863ZM20.6055 10.9863C20.6055 11.3901 20.2769 11.7188 19.873 11.7188C19.4692 11.7188 19.1406 11.3901 19.1406 10.9863C19.1406 10.5825 19.4692 10.2539 19.873 10.2539C20.2769 10.2539 20.6055 10.5825 20.6055 10.9863Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6074 13.0605C13.9438 13.2847 14.3984 13.1938 14.623 12.8574L20.4824 4.06834C20.7065 3.73192 20.6157 3.27684 20.2793 3.05272C19.9429 2.8286 19.4878 2.91942 19.2637 3.25584L13.4043 12.0449C13.1797 12.3813 13.271 12.8359 13.6074 13.0605Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2676 0H0.732422C0.328125 0 0 0.328125 0 0.732422V5.12695C0 5.53125 0.328125 5.85938 0.732422 5.85938C1.94385 5.85938 2.92969 6.84521 2.92969 8.05664C2.92969 9.26807 1.94385 10.2539 0.732422 10.2539C0.328125 10.2539 0 10.582 0 10.9863V15.3809C0 15.7852 0.328125 16.1133 0.732422 16.1133H24.2676C24.6719 16.1133 25 15.7852 25 15.3809V0.732422C25 0.328125 24.6719 0 24.2676 0ZM23.5352 14.6484H7.32422V13.916C7.32422 13.5117 6.99609 13.1836 6.5918 13.1836C6.1875 13.1836 5.85938 13.5117 5.85938 13.916V14.6484H1.46484V11.645C3.13428 11.3047 4.39453 9.8252 4.39453 8.05664C4.39453 6.28809 3.13428 4.80859 1.46484 4.46826V1.46484H5.92041V2.19727C5.92041 2.60156 6.24854 2.92969 6.65283 2.92969C7.05713 2.92969 7.38525 2.60156 7.38525 2.19727V1.46484H23.5352V14.6484Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5918 8.78906C6.1875 8.78906 5.85938 9.11719 5.85938 9.52148V10.9863C5.85938 11.3906 6.1875 11.7188 6.5918 11.7188C6.99609 11.7188 7.32422 11.3906 7.32422 10.9863V9.52148C7.32422 9.11719 6.99609 8.78906 6.5918 8.78906Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5918 4.39453C6.1875 4.39453 5.85938 4.72266 5.85938 5.12695V6.5918C5.85938 6.99609 6.1875 7.32422 6.5918 7.32422C6.99609 7.32422 7.32422 6.99609 7.32422 6.5918V5.12695C7.32422 4.72266 6.99609 4.39453 6.5918 4.39453Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 16.1133,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponUnSelected);
export default __webpack_public_path__ + "static/media/couponUnSelected.551aa2311f85cd52aa925d5cf281ed4c.svg";
export { ForwardRef as ReactComponent };